module.exports = __webpack_public_path__ + "assets/img/about_map.780c96b3.png";